import { supabase } from "./supabase";
import type { Profile, Wallet } from "../types";

export type ProfileWalletBundle = {
  profile: Profile | null;
  wallet: Wallet | null;
};

/** 集中拉取当前用户的 profile + wallet，供 Zustand 与 React Query 共用，避免重复 SQL 与分叉逻辑 */
export async function fetchProfileAndWallet(
  userId: string
): Promise<ProfileWalletBundle> {
  const { data: profile } = await supabase
    .from("profiles")
    .select("*")
    .eq("id", userId)
    .single();

  const { data: wallet } = await supabase
    .from("wallets")
    .select("*")
    .eq("user_id", userId)
    .maybeSingle();

  return { profile, wallet };
}

export interface IProfileWalletService {
  fetchProfileAndWallet(userId: string): Promise<ProfileWalletBundle>;
}

export const profileWalletService: IProfileWalletService = {
  fetchProfileAndWallet,
};
